<template>
    <div>
        <PasoExtraRecintoAnexo
            v-if="!show_svg_plazas_parking"
            key="pasoExtraRA"
            id="pasoExtraRA"
            :texto_producto_extra="$t('nuevo_abono.parking_extra')"
            @continuarProductoExtra="avanzarPaso"
        />

        <SeleccionarAsientosConRegiones 
            v-else
            :disabled="disabled"
            :changeSeat="changeSeat" 
            :abonado="abonado" 
            :recuperarSoloZonaAnexas="true"
            @butacasBloqueadas="butacasBloqueadas"
            @sessionButacaData="sessionButacaDataPadre"
            @continuarSinPlazaParking="continuarSinPlazaParking"
        />>
    </div>
</template>

<script>
    import PasoExtraRecintoAnexo from '../../events/compra/components/recinto-anexo/PasoExtraRecintoAnexo.vue';
    import SeleccionarAsientosConRegiones from '@/components/frontend/abonos/nuevo/SeleccionarAsientosConRegiones.vue';

    export default {
        props: {
            disabled: {
                type: Boolean,
                required: true
            },
            changeSeat: {
                type: Number,
                required: true
            },
            abonado: {
                type: [Object, null],
                required: false
            }
        },
        data() {
            return {
                show_svg_plazas_parking: false
            }
        },
        methods: {
            avanzarPaso(quiere_plaza) {
                if (quiere_plaza) {
                    this.show_svg_plazas_parking = true;
                }
                this.$emit('avanzarPaso', quiere_plaza);
            },
            butacasBloqueadas(datos_compradores, asientos, zona, session_id, zonas_anexas) {
                this.$emit('butacasBloqueadas', datos_compradores, asientos, zona, session_id, zonas_anexas);
            },
            sessionButacaDataPadre(data) {
                this.$emit('sessionButacaData', data);
            },
            continuarSinPlazaParking() {
                this.show_svg_plazas_parking = false;
                this.$emit('continuarSinPlazaParking');
            }
        },
        components: {
            PasoExtraRecintoAnexo, SeleccionarAsientosConRegiones
        }
    }
</script>